module.exports = __webpack_public_path__ + "main-navbar-logo.ea251ea84b08e07b9e82.png";